<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    const script = document.createElement('script')
    script.src = 'https://s22.cnzz.com/z_stat.php?id=1274821032'
    script.language = 'JavaScript'
    document.body.appendChild(script);
  },
  watch: {
    '$route' () {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUlr = '/'
        window._czc.push(['_trackPageview', contentUrl, refererUlr])
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
